<template>
  <div class="home">
    <hero-section />
    <values-section section-title="核心价值" :core-values="ctx.coreValues" />
    <CoreFeaturesSection :core-features="ctx.coreFeatures" :products="ctx.products" />
    <audience-section />
    <company-intro-section />
<!--    <cta-section />-->
    <partners-section :partners="ctx.partners" />
    <float-nav
      v-if="!isMobile"
      :anchor-items="floatAnchors"
      :active-anchor="activeAnchor"
      @scroll-to="scrollTo"
    />
  </div>
</template>

<script>
import HeroSection from "../components/HeroSection.vue";
import CompanyIntroSection from "../components/CompanyIntroSection.vue";
import ValuesSection from "../components/ValuesSection.vue";
import AudienceSection from "../components/AudienceSection.vue";
import CtaSection from "../components/CtaSection.vue";
import PartnersSection from "../components/PartnersSection.vue";
import FloatNav from "../components/FloatNav.vue";

export default {
  components: {
    HeroSection,
    CompanyIntroSection,
    ValuesSection,
    AudienceSection,
    CtaSection,
    PartnersSection,
    FloatNav
  },
  inject: ["officialShell"],
  data() {
    return {
      activeAnchor: "hero",
      isMobile: false
    };
  },
  computed: {
    ctx() {
      return this.officialShell.ctx;
    },
    floatAnchors() {
      return [
        { key: "hero", label: "首屏" },
        { key: "values", label: "价值" },
        { key: "features", label: "功能" },
        { key: "intro", label: "简介" },
        { key: "partners", label: "伙伴" },
      ];
    }
  },
  watch: {
    "$route.hash": "applyHashScroll"
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.updateViewport, { passive: true });
    this.$nextTick(() => this.applyHashScroll());
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    scrollTo(sectionId) {
      const section = document.getElementById(sectionId);
      if (!section) return;
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    applyHashScroll() {
      const hash = this.$route.hash && this.$route.hash.replace(/^#/, "");
      if (!hash) return;
      this.$nextTick(() => {
        this.scrollTo(hash);
      });
    },
    handleScroll() {
      const ids = this.floatAnchors.map((item) => item.key);
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        const rect = el.getBoundingClientRect();
        if (rect.top <= 120 && rect.bottom > 120) {
          this.activeAnchor = id;
        }
      });
    },
    updateViewport() {
      this.isMobile = window.innerWidth < 992;
    }
  }
};
</script>

<style scoped>
.home {
  min-height: 40vh;
}
</style>
